import { Box, FormControl, FormLabel, Select } from '@chakra-ui/react';
import { Firebase } from './Firebase';
import { OAuth } from './OAuth';

import { RegisterData } from '@providers/useUserContext';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Logout } from './Logout';
import('react-phone-number-input/style.css');

export const Auth = {
  Firebase,
  OAuth,
  Logout,
};

export function ShoeSizeSelect() {
  const { register, watch } = useFormContext<RegisterData>();
  const shoeSize = watch('CustomFields.ShoeSize');
  const { t } = useTranslation();
  const min = 25;
  const max = 50;
  const options = Array.from({ length: max - min }, (_, i) => i + min);

  return (
    <FormControl>
      <Box maxWidth={'400px'}>
        <FormLabel>{t('Pointure de chaussure*')}</FormLabel>
        <Select required {...register('CustomFields.ShoeSize', { valueAsNumber: true })} value={shoeSize || ''}>
          <option disabled value="">
            {t('Sélectionner une pointure')}
          </option>
          {options.map((option, index) => (
            <option key={index} value={option}>
              {option}
            </option>
          ))}
        </Select>
      </Box>
    </FormControl>
  );
}
